var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "agent-badge d-inline-flex align-center",
      attrs: {
        "aria-label": _vm.ariaLabel,
        title: _vm.mostraMotivo ? _vm.motivo : null,
        "aria-describedby": _vm.mostraMotivo ? _vm.tooltipId : null
      }
    },
    [
      _c("icon-svg", {
        staticClass: "mr-1 flex-shrink-0",
        attrs: { name: _vm.hubInfo.iconName, size: 14, color: _vm.corIcone }
      }),
      _c(
        "span",
        {
          staticClass: "az-text-secondary az-size-12",
          class: { "ia-shimmer-text": _vm.ehCarregando }
        },
        [_vm._v(" " + _vm._s(_vm.rotuloVisivel) + " ")]
      ),
      _vm.mostraMotivo
        ? _c("span", { staticClass: "sr-only", attrs: { id: _vm.tooltipId } }, [
            _vm._v(_vm._s(_vm.motivo))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }